<template>
  <el-form
    :model="ruleForm"
    status-icon
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-form-item label="密码" prop="LoginPWD">
      <el-input
        type="password"
        v-model="ruleForm.LoginPWD"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="LoginPWDConfim">
      <el-input
        type="password"
        v-model="ruleForm.LoginPWDConfim"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
      <el-button @click="resetForm('ruleForm')">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { updPwd } from '../../api/api'
import md5 from '/util/md5'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.LoginPWDConfim !== '') {
          this.$refs.ruleForm.validateField('LoginPWDConfim')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.LoginPWD) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        LoginPWD: '',
        LoginPWDConfim: '',
      },
      rules: {
        LoginPWD: [{ validator: validatePass, trigger: 'blur' }],
        LoginPWDConfim: [{ validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //updPwd
          updPwd({
            LoginPWD: md5(md5(this.ruleForm.LoginPWD)),
            LoginPWDConfim: md5(md5(this.ruleForm.LoginPWDConfim)),
          }).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style></style>
